const products = [
  {
    id: 1,
    brand: "Nike",
    name: "Air Max 270",
    category: "Shoes",
    originalPrice: 130,
    salePrice: 65,
    discount: 50,
    image: "👟",
    link: "https://nike.com"
  },
  {
    id: 2,
    brand: "Adidas",
    name: "Ultraboost 22",
    category: "Shoes",
    originalPrice: 180,
    salePrice: 99,
    discount: 45,
    image: "👟",
    link: "https://adidas.com"
  },
  {
    id: 3,
    brand: "H&M",
    name: "Puffer Jacket",
    category: "Clothing",
    originalPrice: 80,
    salePrice: 28,
    discount: 65,
    image: "🧥",
    link: "https://hm.com"
  },
  {
    id: 4,
    brand: "Zara",
    name: "Linen Dress",
    category: "Clothing",
    originalPrice: 80,
    salePrice: 32,
    discount: 60,
    image: "👗",
    link: "https://zara.com"
  },
  {
    id: 5,
    brand: "Gap",
    name: "Slim Chinos",
    category: "Clothing",
    originalPrice: 60,
    salePrice: 30,
    discount: 50,
    image: "👖",
    link: "https://gap.com"
  },
  {
    id: 6,
    brand: "Puma",
    name: "Training Shorts",
    category: "Sports",
    originalPrice: 40,
    salePrice: 18,
    discount: 55,
    image: "🩳",
    link: "https://puma.com"
  },
  {
    id: 7,
    brand: "Nike",
    name: "Training Gloves",
    category: "Accessories",
    originalPrice: 40,
    salePrice: 18,
    discount: 55,
    image: "🧤",
    link: "https://nike.com"
  },
  {
    id: 8,
    brand: "Adidas",
    name: "Essentials Tee",
    category: "Clothing",
    originalPrice: 30,
    salePrice: 18,
    discount: 40,
    image: "👕",
    link: "https://adidas.com"
  }
];

export default products;